<label
    class="pb-1 text-sm font-bold"
    [class.text-black]="!isDarkMode()"
    [class.text-white]="isDarkMode()"
    [for]="formControlName"
    >{{ label() }}
    @if (required()) {
        <span class="text-red">*</span>
    }
</label>

<div
    class="flex items-center gap-2 rounded-md border border-grey-150"
    [class.bg-gray-100]="!editable()"
    [class.opacity-50]="!editable()">
    <ng-content></ng-content>
    @if (type() === 'phone') {
        <div class="form-element w-full">
            <input
                ng2TelInput
                [id]="formControlName"
                [placeholder]="placeholder()"
                [value]="internalValue()"
                [disabled]="disabled()"
                (input)="onInputChange($event)"
                (blur)="onInputBlur()"
                class="w-full rounded-md border-2 p-2 text-black outline-hidden transition placeholder:text-grey-500 focus:border-2 disabled:cursor-not-allowed disabled:opacity-70"
                type="text" />
        </div>
    } @else {
        <input
            [id]="formControlName"
            [placeholder]="placeholder()"
            [value]="internalValue()"
            [disabled]="disabled()"
            (input)="onInputChange($event)"
            (blur)="onInputBlur()"
            class="w-full rounded-md border-2 p-2 text-black outline-hidden transition placeholder:text-grey-500 focus:border-2 disabled:cursor-not-allowed disabled:opacity-70"
            [type]="type()" />
    }
</div>
@if (errors()?.['required']) {
    <p class="text-sm font-medium text-red">{{ label() }} is required</p>
}
@if (errors()?.['email']) {
    <p class="text-sm font-medium text-red">Email is invalid</p>
}
@if (errors()?.['minlength']) {
    <p class="text-sm font-medium text-red">
        {{ label() }} must be at least
        {{ errors()['minlength'].requiredLength }} characters long
    </p>
}
@if (errors()?.['maxlength']) {
    <p class="text-sm font-medium text-red">
        {{ label() }} cannot be more than
        {{ errors()['maxlength'].requiredLength }} characters long
    </p>
}
@if (errors()?.['pattern']) {
    <p class="text-sm font-medium text-red">{{ label() }} is invalid</p>
}
@if (errors()?.['phonenumberInvalid']) {
    <p class="text-sm font-medium text-red">{{ label() }} is invalid</p>
}
@if (errors()?.['server']) {
    <p class="text-sm font-medium text-red">{{ errors()['server'] }}</p>
}
@if (errors()?.['mustMatch']) {
    <p class="text-sm font-medium text-red">Passwords do not match</p>
}
